(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("package-picker-studio", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["package-picker-studio"] = factory(require("React"), require("ReactDOM"));
	else
		root["package-picker-studio"] = factory(root["React"], root["ReactDOM"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__4883__, __WEBPACK_EXTERNAL_MODULE__81845__) => {
return 